// Synthesized game-show sounds (Web Audio — no downloads, always plays)
// + haptic helpers. All cues double as accessibility signals for blind players.

let ctx = null;

function ac() {
  try {
    if (!ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      ctx = new AC();
    }
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
  } catch (e) {
    return null;
  }
}

// iOS/Safari only produce sound after a user gesture — arm it on first touch.
export function unlockAudio() {
  const arm = () => { ac(); };
  window.addEventListener("pointerdown", arm, { once: true, passive: true });
  window.addEventListener("keydown", arm, { once: true });
}

function tone(freq, start, dur, { type = "triangle", gain = 0.16, slideTo = null } = {}) {
  const c = ac();
  if (!c) return;
  const t0 = c.currentTime + start;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  if (slideTo) osc.frequency.exponentialRampToValueAtTime(slideTo, t0 + dur);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(gain, t0 + 0.015);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.05);
}

export function playDing() {
  if (!ac()) return;
  tone(659, 0, 0.16, { gain: 0.18 });
  tone(880, 0.09, 0.2, { gain: 0.16 });
  tone(1318, 0.18, 0.35, { gain: 0.14 });
}

export function playBuzz() {
  if (!ac()) return;
  tone(150, 0, 0.32, { type: "sawtooth", gain: 0.12 });
  tone(112, 0.02, 0.34, { type: "square", gain: 0.07 });
}

export function playFanfare() {
  if (!ac()) return;
  const notes = [523, 659, 784, 1047];
  notes.forEach((f, i) => tone(f, i * 0.13, 0.3, { gain: 0.15 }));
  tone(1047, 0.62, 0.7, { gain: 0.16 });
  tone(1319, 0.7, 0.6, { gain: 0.1, type: "sine" });
}

export function playAlert(urgent = false) {
  if (!ac()) return;
  tone(urgent ? 988 : 784, 0, 0.1, { type: "square", gain: 0.07 });
  if (urgent) tone(1319, 0.12, 0.14, { type: "square", gain: 0.07 });
}

export function playCheckIn() {
  if (!ac()) return;
  tone(784, 0, 0.12, { gain: 0.14 });
  tone(1175, 0.1, 0.25, { gain: 0.14 });
}

export function vibrate(pattern) {
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) navigator.vibrate(pattern);
  } catch (e) { /* no haptics — fine */ }
}
